import { dataStatusIssue } from '../../../Data/dataIssue';
import { useState, useEffect } from 'react';
import ArrowDownIcons from '../../../Icons/ArrowDownIcons';
import ArrowUpIcons from '../../../Icons/ArrowUpIcons';
import TableStatusIssue from './TableIssue/TableStatusIssue';
import ChervonForwardIcons from '../../../Icons/ChevronForwardIcons';
import ChervonBackwardIcons from './../../../Icons/ChervonBackwardIcons';
import ListOptionFilterDay from '../../ComponentReuse/ListOptionFilterDay';
import TableCustomerIssue from './TableIssue/TableCustomerIssue';
import MoreIcons from '../../../Icons/MoreIcons';
import SearchIcons from '../../../Icons/SearchIcons';
import MenuComponent from '../../ComponentReuse/MenusComponent/MenusComponent';
import DownIcons from '../../../Icons/DownIcons';

const ListCSState = [
	'All',
	'New',
	'Open',
	'Pending',
	'Wait on customer',
	'Wait on 3rd party',
	'Resolved',
	'Closed',
];
const listAgents = ['All', 'Ashley', 'Alice P', 'Caroline N', 'Celina V'];
const listIssueKind = [
	'All',
	'Address Confirmation',
	'Ask For Help',
	'Cancel order',
	'Change product details',
	'Change shipping details',
	'Contact PO',
	'Dispute',
	'Fraud',
	'Item not as described/Merchandise',
	'Item not received',
	'Other',
	'Out of stock',
	'Pending',
	'Request for new address',
	'Specify type of product',
	'Unauthorized transaction',
	'Unfulfilled/Late Fulfilled',
];
const listCompany = [
	'All',
	'Address Confirmation',
	'Ask For Help',
	'Cancel order',
	'Change product details',
	'Change shipping details',
	'Contact PO',
	'Dispute',
	'Fraud',
	'Item not as described/Merchandise',
	'Item not received',
	'Other',
	'Out of stock',
	'Pending',
	'Request for new address',
	'Specify type of product',
	'Unauthorized transaction',
	'Unfulfilled/Late Fulfilled',
];
const listChoosen = [
	'Today',
	'Yesterday',
	'Last 7 days',
	'Last 30 days',
	'Last 90 days',
];

const backgroundTheme = (text) => {
	let background = '';
	if (text.lowerCase() === 'new') {
		background = '#AEE9D1';
	} else if (text.lowerCase() === 'wait on 3rd party') {
		background = '#8E59FF';
	} else if (text.lowerCase() === 'wait on customer') {
		background = '#2F80ED';
	} else if (text.lowerCase() === 'pending') {
		background = '#F2C94C';
	} else if (text.lowerCase() === 'resolved') {
		background = '#836100';
	} else if (text.lowerCase() === 'closed') {
		background = '#EFEFEF';
	} else background = '#27AE60';

	return background;
};

const IssueComponents = () => {
	const [currentTab, setCurrentTab] = useState('customer');

	const handleChangeTab = (tab) => {
		setCurrentTab(tab);
	};

	return (
		<>
			<div className="m-4">
				<TableStatusIssue />
			</div>
			<div className="w-full p-4 ">
				<ListOptionFilterDay listChoosen={listChoosen} />
			</div>
			<div className="border rounded-5px m-4">
				<div>
					<div className="flex mobile:flex-wrap gap-4 capitalize border-b">
						<div
							onClick={() => handleChangeTab('customer')}
							style={{
								padding: '12px 16px',
								fontWeight: 400,
								borderBottom:
									currentTab == 'customer'
										? '2px solid rgb(5 150 105)'
										: 'none',
							}}
							className="md:ml-2 md:p-2 mobile:p-0 mobile:ml-0 mobile:mb-0 cursor-pointer hover:border-b-2 text-black text-sm"
						>
							Customer
						</div>
						<div
							onClick={() => handleChangeTab('supplier')}
							style={{
								padding: '12px 16px',
								fontWeight: 400,
								borderBottom:
									currentTab == 'supplier'
										? '2px solid rgb(5 150 105)'
										: 'none',
							}}
							className="md:ml-2 md:p-2 mobile:p-0 mobile:ml-0 mobile:mb-0 cursor-pointer hover:border-b-2 text-black text-sm"
						>
							Supplier
						</div>
						<div
							onClick={() => handleChangeTab('designer')}
							className="md:p-2 hover:border-b-2 text-black text-sm mobile:p-0 mobile:ml-0 mobile:mb-0 cursor-pointer "
							style={{
								borderBottom:
									currentTab == 'designer'
										? '2px solid rgb(5 150 105)'
										: 'none',
								padding: '12px 16px',
								fontWeight: 400,
							}}
						>
							designer
						</div>
						<div
							onClick={() => handleChangeTab('seller')}
							style={{
								borderBottom:
									currentTab == 'seller' ? '2px solid rgb(5 150 105)' : 'none',
								padding: '12px 16px',
								fontWeight: 400,
							}}
							className="md:p-2 hover:border-b-2 text-black text-sm mobile:p-0 mobile:ml-0 mobile:mb-0 cursor-pointer "
						>
							seller
						</div>
						<div
							onClick={() => handleChangeTab('csTeam')}
							activeStyle={{
								borderBottom: '2px solid rgb(5 150 105)',
								fontWeight: '600',
							}}
							style={{
								borderBottom:
									currentTab == 'csTeam' ? '2px solid rgb(5 150 105)' : 'none',
								padding: '12px 16px',
								fontWeight: 400,
							}}
							className="md:p-2 hover:border-b-2 text-black text-sm mobile:p-0 mobile:ml-0 mobile:mb-0 cursor-pointer "
						>
							CS team
						</div>
					</div>
				</div>
				<div className="flex mx-2 mobile:flex-wrap xl:flex-nowrap items-center md:items-center">
					<div className="flex items-center grow ">
						<MenuComponent
							icons={<MoreIcons />}
							list={['Assign to CS', 'Change CS State']}
						/>
						<div className="inline-flex grow m-2 items-center text-sm w-full">
							<div
								className={
									'w-full flex bg-secondary border rounded-5px p-1 overflow-hidden '
								}
							>
								<SearchIcons styled="mt-1" />
								<input
									placeholder={`Search template...`}
									className="w-full border-none visited:border-none bg-secondary focus:outline-none ml-2"
								/>
							</div>
						</div>
					</div>
					<div className="flex gap-2 mobile:flex-wrap xl:flex-nowrap mobile:mb-2 md:mb-0 ">
						<MenuComponent
							title="CS State"
							list={ListCSState}
							icons={<DownIcons />}
						/>
						<MenuComponent
							title="Agents"
							list={listAgents}
							icons={<DownIcons />}
						/>
						<MenuComponent
							title="Issue Kind"
							list={listIssueKind}
							icons={<DownIcons />}
						/>
						<MenuComponent
							title="Company"
							list={listCompany}
							icons={<DownIcons />}
						/>
					</div>
				</div>

				<div className="">
					{currentTab == 'customer' && <TableCustomerIssue />}
				</div>
			</div>
		</>
	);
};
export default IssueComponents;
